// extracted by mini-css-extract-plugin
module.exports = {"main":"layout_main__p9sau","noAnnouncementBar":"layout_noAnnouncementBar__Il4t9"};